import { createContext, useContext, useState, useCallback, useEffect } from "react";

export const translations = {
  de: {
    langLabel: "DE",
    nav: { ueber: "Über", leistungen: "Leistungen", referenzen: "Referenzen", standort: "Standort", kontakt: "Kontakt" },
    hero: {
      kicker: "Architekturbüro · Sterzing · Südtirol",
      tagline: "Begleitung vom ersten Gespräch bis zur Fertigstellung.",
      credential: "Arch. Junior — Architektenkammer Bozen · Nr. 1833",
      scroll: "Scroll",
      logoHint: "Doppelklick fürs Traumhaus",
    },
    about: {
      label: "01 — Über mich",
      headingLines: ["Präzision,", "Verantwortung", "& Nähe."],
      portraitAlt: "Achim Gasteiger — Architekt in Sterzing, Südtirol",
      paragraph:
        "Vom ersten Gespräch bis zur Fertigstellung begleite ich Ihr Bauvorhaben persönlich — mit dem Anspruch, gestalterische Qualität und technische Sorgfalt in Einklang zu bringen.",
      timeline: [
        {
          year: "2006–2011",
          title: "Oberschule für Geometer",
          text: "Ausbildung an der Oberschule für Geometer — technische und zeichnerische Grundausbildung.",
        },
        {
          year: "2010–2025",
          title: "Mitarbeit",
          text: "Langjähriger Mitarbeiter im Planungsbüro Geom. Herbert Seeber — praktische Erfahrung in Planung und Projektierung.",
        },
        {
          year: "2023",
          title: "Bachelor of Science",
          text: "Abschluss des Architekturstudiums an der Universität Innsbruck als Bachelor of Science.",
        },
        {
          year: "2025",
          title: "Eintragung & Selbstständigkeit",
          text: "Eintragung in die Architektenkammer unter Nummer 1833 und Beginn der selbstständigen Tätigkeit als Architekt.",
        },
      ],
    },
    services: {
      label: "02 — Tätigkeitsbereiche",
      heading: "Leistungen",
      intro: "Ein durchgängiges Leistungsspektrum — von der ersten Idee bis zur schlüsselfertigen Übergabe.",
      inquire: "Dazu anfragen",
      inquireEmail: "Per E-Mail",
      inquireWhatsapp: "Per WhatsApp",
      inquireSubject: "Anfrage zu",
      inquireMsg:
        "Guten Tag Herr Gasteiger,\n\nich interessiere mich für Ihre Leistung „{title}“ und möchte gerne einen Termin für ein Erstgespräch vereinbaren.\n\nMein Vorhaben: \nGewünschter Zeitraum: \n\nName: \nTelefon: \n\nVielen Dank!",
      items: [
        [
          "Vorstudie",
          "Analyse, Machbarkeit und erste konzeptionelle Ausrichtung.",
          "Ich prüfe Grundstück, Bauvorschriften und Machbarkeit, entwickle erste Konzeptvarianten und schaffe so eine belastbare Entscheidungsgrundlage — noch bevor größere Kosten entstehen.",
        ],
        [
          "Einreichplanung",
          "Vollständige Unterlagen für die behördliche Genehmigung.",
          "Ich erstelle sämtliche Pläne und Unterlagen für die Baukonzession bzw. die zuständigen Ämter und begleite das Genehmigungsverfahren bis zur Freigabe.",
        ],
        [
          "Ausführungsplanung",
          "Detaillierte Pläne für die bauliche Umsetzung.",
          "Detail- und Werkpläne mit allen Maßen, Materialien und Anschlüssen — die verbindliche Grundlage für die ausführenden Firmen und eine reibungslose Umsetzung.",
        ],
        [
          "Bauleitung",
          "Steuerung, Kontrolle und Koordination auf der Baustelle.",
          "Ich koordiniere Firmen und Gewerke, überwache Termine, Qualität und Kosten auf der Baustelle und sorge dafür, dass gebaut wird wie geplant.",
        ],
        [
          "Sicherheitskoordination",
          "Planung und Überwachung der Baustellensicherheit.",
          "Erstellung des Sicherheits- und Koordinierungsplans sowie Überwachung der Arbeitssicherheit während der gesamten Bauzeit (gem. D.Lgs. 81/2008).",
        ],
        [
          "Gebäudekatastermeldungen",
          "Katastermeldungen und Aktualisierung der Gebäudedaten.",
          "Katastereintragungen und -aktualisierungen (z. B. DOCFA) für neue oder veränderte Gebäude — inklusive Abstimmung mit dem Katasteramt.",
        ],
        [
          "Materielle Hausteilungspläne",
          "Erstellung materieller Teilungspläne für Immobilien.",
          "Materielle Teilungspläne zur Aufteilung von Immobilien in eigenständige Einheiten — Grundlage für Verkauf, Erbteilung oder Miteigentum.",
        ],
        [
          "Schätzungen",
          "Wertermittlungen und fundierte Immobilienschätzungen.",
          "Fundierte Wertermittlungen und Gutachten für Kauf, Verkauf, Bank oder Erbschaft — nachvollziehbar dokumentiert.",
        ],
        [
          "Klimahausberechnungen",
          "Energetische Berechnungen nach KlimaHaus-Standard.",
          "Energetische Berechnungen und Nachweise nach KlimaHaus-Standard für effiziente, zukunftssichere Gebäude.",
        ],
        [
          "APE-Meldungen",
          "Erstellung und Meldung des Energieausweises (APE).",
          "Erstellung und amtliche Hinterlegung des Energieausweises (APE) — erforderlich bei Verkauf, Vermietung und Fertigstellung.",
        ],
        [
          "ENEA-Meldungen",
          "Meldung von Sanierungen an die ENEA für Steuerabzüge (Ecobonus & Bonus Casa).",
          "Fristgerechte Meldung energetischer Sanierungen an die ENEA zur Sicherung der Steuerabzüge (Ecobonus & Bonus Casa).",
        ],
      ],
    },
    marquee: ["ACHIM GASTEIGER", "ARCHITEKTUR", "STERZING", "SÜDTIROL", "PLANUNG", "BAULEITUNG"],
    references: {
      label: "03 — Referenzen",
      heading: "Referenzen",
      intro: "Ausgewählte aktuelle und abgeschlossene Projekte.",
      items: [
        ["Sanierung und Erweiterung Haus T", "Giggelberg", "2025–26"],
        ["Neubau Firmensitz Energy On Site GmbH", "Sterzing", "2026–laufend"],
      ],
      summary: [
        ["100+", "weitere Arbeiten"],
        ["100+", "Projekte in Mitarbeit"],
      ],
    },
    location: {
      label: "04 — Bürositz",
      headingLines: ["Sterzing,", "Südtirol."],
      addressLines: ["Geizkoflerstraße 5", "39049 Sterzing (BZ)"],
      explore: "Karte erkunden",
      view3d: "3D-Ansicht",
      route: "Route starten",
      hoursLabel: "Öffnungszeiten",
      hours: "Mo–Fr 08:00–13:00 & 14:00–17:00",
      hoursNote: "Feiertage ausgenommen · Termin nach Vereinbarung erwünscht",
      openNow: "Jetzt geöffnet",
      closedNow: "Geschlossen",
      mapLight: "Helle Karte",
      mapDark: "Dunkle Karte",
      overlay: "Klicken zum Erkunden",
      popupTitle: "Achim Gasteiger Architektur",
    },
    contact: {
      label: "05 — Kontakt",
      headingLines: ["Sprechen wir", "über Ihr Vorhaben."],
      phoneLabel: "Telefon",
      emailLabel: "E-Mail",
      pecLabel: "PEC — Zertifizierte E-Mail",
      saveContact: "Kontakt speichern",
      bookLabel: "Oder direkt Termin anfragen",
      bookEmail: "Per E-Mail",
      bookWhatsapp: "Per WhatsApp",
      bookSubject: "Terminanfrage — Erstgespräch",
      bookMsg:
        "Guten Tag Herr Gasteiger,\n\nich möchte gerne einen Termin für ein Erstgespräch vereinbaren.\n\nMein Vorhaben: \nGewünschter Zeitraum: \n\nName: \nTelefon: \n\nVielen Dank!",
      googleProfile: "Google-Profil",
      whatsapp: "WhatsApp",
      qrCaption: "Kontakt scannen",
      qrHint: "Scannen oder tippen — Kontakt direkt speichern",
      pecInfo: "Zertifizierte E-Mail (PEC) mit rechtlicher Beweiskraft — vor allem für den Verkehr mit Behörden und Unternehmen in Italien.",
      officeLabel: "Büro",
      taxLabel: "Steuernummer",
      vatLabel: "MwSt-Nummer",
      sdiLabel: "SDI-Kodex",
      chamberLabel: "Kammer",
      chamberValue: "Architektenkammer · Nr. 1833",
      copyright: "Alle Rechte vorbehalten",
    },
    legal: {
      impressumLabel: "Impressum",
      datenschutzLabel: "Datenschutz",
      impressumTitle: "Impressum",
      impressumBody: [
        "Achim Gasteiger — Architekt (Arch. Junior)",
        "Geizkoflerstraße 5, 39049 Sterzing (BZ), Italien",
        "Steuernummer: GSTCHM92C06M067B · MwSt-Nummer: 03280740212",
        "Eintragung in die Architektenkammer der Provinz Bozen unter Nr. 1833.",
        "Telefon: +39 339 796 6579 · E-Mail: arch.gasteiger@gmail.com · PEC: achim.gasteiger@archiworldpec.it",
        "Berufsbezeichnung: Architekt (verliehen in Italien). Verantwortlich für den Inhalt dieser Website ist Achim Gasteiger.",
      ],
      datenschutzTitle: "Datenschutzerklärung",
      datenschutzBody: [
        {
          t: "1. Verantwortlicher",
          d: "Verantwortlich für die Datenverarbeitung im Sinne der Datenschutz-Grundverordnung (DSGVO) sowie der italienischen Datenschutzbestimmungen (D.lgs. 196/2003 i.d.F. des D.lgs. 101/2018) ist: Achim Gasteiger, Geizkoflerstraße 5, 39049 Sterzing (BZ), Italien. Telefon: +39 339 796 6579, E-Mail: arch.gasteiger@gmail.com, PEC: achim.gasteiger@archiworldpec.it.",
        },
        {
          t: "2. Allgemeine Grundsätze",
          d: "Der Schutz Ihrer personenbezogenen Daten ist mir ein wichtiges Anliegen. Personenbezogene Daten werden ausschließlich im Rahmen der geltenden gesetzlichen Bestimmungen und nach den Grundsätzen der Datenminimierung und Zweckbindung verarbeitet.",
        },
        {
          t: "3. SSL-/TLS-Verschlüsselung",
          d: "Diese Website nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie am Präfix „https://“ in der Adresszeile sowie am Schloss-Symbol Ihres Browsers. Bei aktiver Verschlüsselung können die übermittelten Daten nicht von Dritten mitgelesen werden.",
        },
        {
          t: "4. Server-Logfiles",
          d: "Der Hosting-Anbieter erhebt und speichert automatisch Informationen in Server-Logfiles, die Ihr Browser übermittelt: Browsertyp und -version, Betriebssystem, Referrer-URL, Hostname, Uhrzeit der Anfrage und IP-Adresse. Diese Daten werden nicht mit anderen Quellen zusammengeführt und dienen ausschließlich dem technischen Betrieb und der Sicherheit. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einem sicheren Betrieb).",
        },
        {
          t: "5. Cookies & Tracking",
          d: "Diese Website setzt keine Marketing- oder Tracking-Cookies ein und erstellt keine Nutzerprofile zu Werbezwecken. Es werden lediglich technisch notwendige Funktionen verwendet (z. B. die lokale Speicherung Ihrer bevorzugten Sprache im „localStorage“ des Browsers). Diese Information verbleibt auf Ihrem Gerät und wird nicht an mich übertragen.",
        },
        {
          t: "6. Kartendienst (OpenStreetMap / CARTO)",
          d: "Zur Darstellung des Standorts wird eine interaktive Karte auf Basis von OpenStreetMap und CARTO eingebunden. Beim Laden werden Kartenkacheln geladen und Ihre IP-Adresse an die Server dieser Anbieter übermittelt. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO.",
        },
        {
          t: "7. Schriftarten",
          d: "Zur einheitlichen Darstellung werden Schriftarten von externen Anbietern (Google Fonts, Fontshare) geladen. Dabei kann Ihre IP-Adresse an die Server der Anbieter übermittelt werden. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO.",
        },
        {
          t: "8. Kontaktaufnahme",
          d: "Wenn Sie per Telefon, E-Mail oder PEC Kontakt aufnehmen, werden Ihre Angaben zur Bearbeitung der Anfrage und für Anschlussfragen gespeichert. Diese Website enthält kein Kontaktformular; über die Seite selbst werden keine Daten aktiv erhoben. Rechtsgrundlage: Art. 6 Abs. 1 lit. b und lit. f DSGVO.",
        },
        {
          t: "9. Speicherdauer",
          d: "Personenbezogene Daten werden nur so lange gespeichert, wie es für die jeweiligen Zwecke erforderlich ist oder gesetzliche Aufbewahrungsfristen (z. B. steuer- und handelsrechtliche Pflichten) dies vorschreiben. Danach werden die Daten gelöscht.",
        },
        {
          t: "10. Weitergabe an Dritte",
          d: "Eine Weitergabe Ihrer Daten an Dritte erfolgt nicht, es sei denn, dies ist zur Vertragserfüllung erforderlich, Sie haben ausdrücklich eingewilligt oder es besteht eine gesetzliche Verpflichtung.",
        },
        {
          t: "11. Ihre Rechte",
          d: "Sie haben nach der DSGVO das Recht auf Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) sowie ein Widerspruchsrecht (Art. 21). Eine erteilte Einwilligung können Sie jederzeit mit Wirkung für die Zukunft widerrufen. Zur Ausübung genügt eine formlose Mitteilung an die oben genannten Kontaktdaten.",
        },
        {
          t: "12. Beschwerderecht",
          d: "Sind Sie der Ansicht, dass die Verarbeitung Ihrer Daten gegen geltendes Recht verstößt, haben Sie das Recht, sich bei einer Aufsichtsbehörde zu beschweren — in Italien beim „Garante per la protezione dei dati personali“ (www.garanteprivacy.it).",
        },
        {
          t: "13. Änderungen dieser Erklärung",
          d: "Ich behalte mir vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht. Es gilt die jeweils auf dieser Website veröffentlichte Fassung.",
        },
      ],
    },
  },
  it: {
    langLabel: "IT",
    nav: { ueber: "Chi sono", leistungen: "Servizi", referenzen: "Referenze", standort: "Sede", kontakt: "Contatti" },
    hero: {
      kicker: "Studio di architettura · Vipiteno · Alto Adige",
      tagline: "Accompagnamento dal primo colloquio fino alla realizzazione.",
      credential: "Arch. Junior — Ordine degli Architetti Bolzano · N. 1833",
      scroll: "Scorri",
      logoHint: "Doppio clic per la casa dei sogni",
    },
    about: {
      label: "01 — Chi sono",
      headingLines: ["Precisione,", "responsabilità", "& vicinanza."],
      portraitAlt: "Achim Gasteiger — architetto a Vipiteno, Alto Adige",
      paragraph:
        "Dal primo colloquio fino alla realizzazione seguo personalmente il suo progetto — con l'obiettivo di coniugare qualità progettuale e rigore tecnico.",
      timeline: [
        {
          year: "2006–2011",
          title: "Istituto per geometri",
          text: "Formazione presso l'istituto tecnico per geometri — basi tecniche e di disegno.",
        },
        {
          year: "2010–2025",
          title: "Collaborazione",
          text: "Collaboratore di lunga data presso lo studio di progettazione del geom. Herbert Seeber — esperienza pratica in progettazione.",
        },
        {
          year: "2023",
          title: "Bachelor of Science",
          text: "Laurea in Architettura all'Università di Innsbruck (Bachelor of Science).",
        },
        {
          year: "2025",
          title: "Iscrizione e libera professione",
          text: "Iscrizione all'Ordine degli Architetti con il numero 1833 e avvio dell'attività professionale autonoma.",
        },
      ],
    },
    services: {
      label: "02 — Ambiti di attività",
      heading: "Servizi",
      intro: "Un servizio completo e continuo — dalla prima idea fino alla consegna chiavi in mano.",
      inquire: "Richiedi info",
      inquireEmail: "Via e-mail",
      inquireWhatsapp: "Via WhatsApp",
      inquireSubject: "Richiesta su",
      inquireMsg:
        "Buongiorno Arch. Gasteiger,\n\nsono interessato al servizio „{title}“ e vorrei fissare un appuntamento per un primo colloquio.\n\nIl mio progetto: \nPeriodo preferito: \n\nNome: \nTelefono: \n\nGrazie!",
      items: [
        [
          "Studio preliminare",
          "Analisi, fattibilità e primo orientamento concettuale.",
          "Verifico terreno, vincoli urbanistici e fattibilità, sviluppo le prime varianti di concetto e offro così una base decisionale solida — prima ancora di sostenere costi rilevanti.",
        ],
        [
          "Progetto per il permesso",
          "Documentazione completa per l'autorizzazione edilizia.",
          "Predispongo tutti gli elaborati per la concessione edilizia e per gli enti competenti e seguo l'iter autorizzativo fino all'approvazione.",
        ],
        [
          "Progetto esecutivo",
          "Piani dettagliati per la realizzazione dell'opera.",
          "Piani di dettaglio con misure, materiali e nodi costruttivi — la base vincolante per le imprese e per una realizzazione senza intoppi.",
        ],
        [
          "Direzione lavori",
          "Gestione, controllo e coordinamento in cantiere.",
          "Coordino imprese e maestranze, controllo tempi, qualità e costi in cantiere e garantisco che si costruisca come progettato.",
        ],
        [
          "Coordinamento sicurezza",
          "Pianificazione e sorveglianza della sicurezza in cantiere.",
          "Redazione del piano di sicurezza e coordinamento e sorveglianza della sicurezza sul lavoro per tutta la durata del cantiere (D.Lgs. 81/2008).",
        ],
        [
          "Accatastamenti",
          "Denunce catastali e aggiornamento dei dati dell'edificio.",
          "Accatastamenti e aggiornamenti catastali (es. DOCFA) per edifici nuovi o modificati — compreso il rapporto con l'Agenzia del Territorio.",
        ],
        [
          "Piani di divisione materiale",
          "Redazione di piani di divisione materiale degli immobili.",
          "Piani di divisione materiale per suddividere gli immobili in unità autonome — base per vendite, divisioni ereditarie o comproprietà.",
        ],
        [
          "Stime e perizie",
          "Valutazioni e stime immobiliari fondate.",
          "Valutazioni e perizie fondate per acquisto, vendita, banca o successione — documentate in modo trasparente.",
        ],
        [
          "Calcoli CasaClima",
          "Calcoli energetici secondo lo standard CasaClima.",
          "Calcoli e attestati energetici secondo lo standard CasaClima per edifici efficienti e a prova di futuro.",
        ],
        [
          "Certificazione APE",
          "Redazione e trasmissione dell'attestato di prestazione energetica (APE).",
          "Redazione e deposito ufficiale dell'attestato di prestazione energetica (APE) — necessario per vendita, locazione e fine lavori.",
        ],
        [
          "Comunicazioni ENEA",
          "Trasmissione all'ENEA degli interventi per le detrazioni fiscali (Ecobonus e Bonus Casa).",
          "Trasmissione nei termini all'ENEA degli interventi di riqualificazione per assicurare le detrazioni fiscali (Ecobonus e Bonus Casa).",
        ],
      ],
    },
    marquee: ["ACHIM GASTEIGER", "ARCHITETTURA", "VIPITENO", "ALTO ADIGE", "PROGETTAZIONE", "DIREZIONE LAVORI"],
    references: {
      label: "03 — Referenze",
      heading: "Referenze",
      intro: "Progetti selezionati, in corso e completati.",
      items: [
        ["Ristrutturazione e ampliamento Casa T", "Giggelberg", "2025–26"],
        ["Nuova sede aziendale Energy On Site GmbH", "Vipiteno", "2026–in corso"],
      ],
      summary: [
        ["100+", "altri lavori"],
        ["100+", "progetti in collaborazione"],
      ],
    },
    location: {
      label: "04 — Sede dello studio",
      headingLines: ["Vipiteno,", "Alto Adige."],
      addressLines: ["Via Geizkofler 5", "39049 Vipiteno (BZ)"],
      explore: "Esplora la mappa",
      view3d: "Vista 3D",
      route: "Avvia percorso",
      hoursLabel: "Orari di apertura",
      hours: "Lun–Ven 08:00–13:00 & 14:00–17:00",
      hoursNote: "Festivi esclusi · Su appuntamento consigliato",
      openNow: "Aperto ora",
      closedNow: "Chiuso",
      mapLight: "Mappa chiara",
      mapDark: "Mappa scura",
      overlay: "Clicca per esplorare",
      popupTitle: "Achim Gasteiger Architettura",
    },
    contact: {
      label: "05 — Contatti",
      headingLines: ["Parliamo", "del suo progetto."],
      phoneLabel: "Telefono",
      emailLabel: "E-mail",
      pecLabel: "PEC — Posta certificata",
      saveContact: "Salva contatto",
      bookLabel: "Oppure richiedi un appuntamento",
      bookEmail: "Via e-mail",
      bookWhatsapp: "Via WhatsApp",
      bookSubject: "Richiesta appuntamento — primo colloquio",
      bookMsg:
        "Buongiorno Arch. Gasteiger,\n\nvorrei fissare un appuntamento per un primo colloquio.\n\nIl mio progetto: \nPeriodo preferito: \n\nNome: \nTelefono: \n\nGrazie!",
      googleProfile: "Profilo Google",
      whatsapp: "WhatsApp",
      qrCaption: "Scansiona il contatto",
      qrHint: "Scansiona o tocca — salva subito il contatto",
      pecInfo: "Posta elettronica certificata (PEC) con valore legale — soprattutto per comunicazioni con enti e imprese in Italia.",
      officeLabel: "Studio",
      taxLabel: "Codice fiscale",
      vatLabel: "Partita IVA",
      sdiLabel: "Codice SDI",
      chamberLabel: "Ordine",
      chamberValue: "Ordine degli Architetti · N. 1833",
      copyright: "Tutti i diritti riservati",
    },
    legal: {
      impressumLabel: "Note legali",
      datenschutzLabel: "Privacy",
      impressumTitle: "Note legali",
      impressumBody: [
        "Achim Gasteiger — Architetto (Arch. Junior)",
        "Via Geizkofler 5, 39049 Vipiteno (BZ), Italia",
        "Codice fiscale: GSTCHM92C06M067B · Partita IVA: 03280740212",
        "Iscrizione all'Ordine degli Architetti della Provincia di Bolzano con il n. 1833.",
        "Telefono: +39 339 796 6579 · E-mail: arch.gasteiger@gmail.com · PEC: achim.gasteiger@archiworldpec.it",
        "Titolo professionale: Architetto (conseguito in Italia). Responsabile dei contenuti di questo sito è Achim Gasteiger.",
      ],
      datenschutzTitle: "Informativa sulla privacy",
      datenschutzBody: [
        {
          t: "1. Titolare del trattamento",
          d: "Titolare del trattamento ai sensi del Regolamento (UE) 2016/679 (GDPR) e della normativa italiana in materia (D.lgs. 196/2003 come modificato dal D.lgs. 101/2018) è: Achim Gasteiger, Via Geizkofler 5, 39049 Vipiteno (BZ), Italia. Telefono: +39 339 796 6579, e-mail: arch.gasteiger@gmail.com, PEC: achim.gasteiger@archiworldpec.it.",
        },
        {
          t: "2. Principi generali",
          d: "La protezione dei suoi dati personali è per me molto importante. I dati personali vengono trattati esclusivamente nel rispetto delle disposizioni di legge vigenti e secondo i principi di minimizzazione e limitazione della finalità.",
        },
        {
          t: "3. Crittografia SSL/TLS",
          d: "Per motivi di sicurezza e per proteggere la trasmissione di contenuti riservati, questo sito utilizza una crittografia SSL/TLS. Una connessione cifrata è riconoscibile dal prefisso „https://“ nella barra degli indirizzi e dal simbolo del lucchetto nel browser. Con la crittografia attiva, i dati trasmessi non possono essere letti da terzi.",
        },
        {
          t: "4. File di log del server",
          d: "Il provider di hosting raccoglie e memorizza automaticamente informazioni nei file di log del server, trasmesse dal suo browser: tipo e versione del browser, sistema operativo, URL di provenienza (referrer), nome host, orario della richiesta e indirizzo IP. Tali dati non vengono uniti ad altre fonti e servono esclusivamente all'erogazione tecnica e alla sicurezza del sito. Base giuridica: art. 6, par. 1, lett. f) GDPR (legittimo interesse).",
        },
        {
          t: "5. Cookie e tracciamento",
          d: "Questo sito non utilizza cookie di marketing o di tracciamento e non crea profili utente a fini pubblicitari. Vengono impiegate solo funzioni tecnicamente necessarie (ad es. il salvataggio della lingua preferita nel „localStorage“ del browser). Tale informazione rimane sul suo dispositivo e non mi viene trasmessa.",
        },
        {
          t: "6. Servizio cartografico (OpenStreetMap / CARTO)",
          d: "Per la visualizzazione della sede viene integrata una mappa interattiva basata su OpenStreetMap e CARTO. Al caricamento della mappa il suo indirizzo IP viene trasmesso ai server di tali fornitori per l'invio delle tile al browser. Base giuridica: art. 6, par. 1, lett. f) GDPR.",
        },
        {
          t: "7. Font",
          d: "Per una resa grafica uniforme vengono caricati font da fornitori esterni (Google Fonts, Fontshare). In tale contesto il suo indirizzo IP può essere trasmesso ai server dei fornitori. Base giuridica: art. 6, par. 1, lett. f) GDPR.",
        },
        {
          t: "8. Contatti",
          d: "Se mi contatta per telefono, e-mail o PEC, i suoi dati verranno conservati per gestire la richiesta ed eventuali domande successive. Il sito non contiene moduli di contatto; attraverso il sito non vengono raccolti attivamente dati. Base giuridica: art. 6, par. 1, lett. b) e f) GDPR.",
        },
        {
          t: "9. Periodo di conservazione",
          d: "I dati personali vengono conservati solo per il tempo necessario alle relative finalità o secondo gli obblighi di legge (ad es. obblighi fiscali e contabili). Successivamente vengono cancellati.",
        },
        {
          t: "10. Comunicazione a terzi",
          d: "I suoi dati personali non vengono comunicati a terzi, salvo che ciò sia necessario per l'esecuzione di un contratto, lei abbia espressamente acconsentito o sussista un obbligo di legge.",
        },
        {
          t: "11. I suoi diritti",
          d: "Ai sensi del GDPR lei ha diritto di accesso (art. 15), rettifica (art. 16), cancellazione (art. 17), limitazione del trattamento (art. 18), portabilità dei dati (art. 20) e opposizione (art. 21). Può inoltre revocare in qualsiasi momento un consenso prestato, con effetto per il futuro. Per esercitare i suoi diritti è sufficiente una comunicazione informale ai recapiti sopra indicati.",
        },
        {
          t: "12. Diritto di reclamo",
          d: "Qualora ritenga che il trattamento dei suoi dati violi la normativa vigente, ha il diritto di proporre reclamo a un'autorità di controllo — in Italia il „Garante per la protezione dei dati personali“ (www.garanteprivacy.it).",
        },
        {
          t: "13. Modifiche alla presente informativa",
          d: "Mi riservo di aggiornare la presente informativa affinché sia sempre conforme ai requisiti di legge vigenti. Vale la versione di volta in volta pubblicata su questo sito.",
        },
      ],
    },
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  // Always start in German on every load. The language can only be changed
  // via the in-page switcher and does not persist across reloads.
  const [lang, setLang] = useState("de");
  const changeLang = useCallback((l) => {
    if (l === "de" || l === "it") setLang(l);
  }, []);
  useEffect(() => {
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);
  const value = { lang, setLang: changeLang, t: translations[lang] };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
